import { createRequestFilterCommands } from '../request-filter';
import { requestsActions } from '../requests.actions';

export const requestFilterCommands = createRequestFilterCommands(
  requestsActions
);
